<template>
  <div
    class="brand-body relative z-10 mx-auto mb-8 max-w-3xl overflow-hidden bg-white shadow-lg sm:mb-10"
  >
    <!-- Slim gold accent marks this as the home course -->
    <div class="h-1 w-full bg-gradient-to-r from-secondary-200 to-secondary-500" />

    <div class="bg-white">
      <div class="relative">
        <img
          src="/img/club613/cover.jpg"
          class="w-full object-cover pb-2"
          style="height: 130px"
        >
        <!-- Subtle "home course" badge -->
        <div class="absolute left-3 top-3 flex items-center gap-2 rounded-full bg-white/95 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-500 shadow-sm">
          <span class="h-1.5 w-1.5 rounded-full bg-secondary-500" />
          Your home course
        </div>
      </div>

      <div
        class="brand-heading ml-3 inline w-auto border-b-2 border-brand-800 p-2 pt-0 text-xl tracking-wide sm:ml-5 sm:text-2xl"
      >
        Virtus Golf
      </div>

      <div class="brand-body p-3 pt-4 text-sm xs:text-base sm:p-5">
        Your home course in Scottsdale, Arizona. Live tee sheet, instant confirmation — book your next
        round in seconds, with no request needed.
      </div>
    </div>

    <router-link to="/booking/clubs/613">
      <PrimaryButton
        :text="'View tee times'"
        :full-width="true"
      />
    </router-link>
  </div>
</template>

<script>
import PrimaryButton from '../base/button/primaryButton.vue';

export default {
  name: 'VirtusHomeClubCard',

  components: {
    PrimaryButton,
  },
};
</script>
